import { defineStore } from "pinia";
import type { ManufacturersStore } from "~/types/common";

export const useManufacturersStore = defineStore("manufacturersStore", {
  state: (): ManufacturersStore => ({
    manufacturers: [],
  }),
});
